import { render, staticRenderFns } from "./ItemDetail.vue?vue&type=template&id=c56b6076&scoped=true"
import script from "./ItemDetail.vue?vue&type=script&lang=js"
export * from "./ItemDetail.vue?vue&type=script&lang=js"
import style0 from "./ItemDetail.vue?vue&type=style&index=0&id=c56b6076&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56b6076",
  null
  
)

export default component.exports